//This is the screen where all teachers registered will display in table format
import { Box } from '@chakra-ui/react'
import TeacherOverview from '../components/TeacherOverview'

const AllTeacherScreen = () => {
  return (
    <Box>
    <TeacherOverview/>    
    </Box>
  )
}

export default AllTeacherScreen
